document.addEventListener('DOMContentLoaded', function () {

    var section = document.querySelector('[data-cart-greeting]');
    if (!section) return;

    var cards = section.querySelectorAll('[data-card]');
    var modal = document.querySelector('[data-cart-greeting-modal]');
    var modalCloseEls = modal.querySelectorAll('[data-cart-greeting-close]');
    var modalReturn = modal.querySelector('[data-cart-greeting-return]');
    var textarea = modal.querySelector('[data-cart-greeting-textarea]');
    var countEl = modal.querySelector('[data-cart-greeting-count]');
    var addBtn = modal.querySelector('[data-cart-greeting-add]');
    var errorEl = modal.querySelector('[data-cart-greeting-error]');
    var imgFront = modal.querySelector('[data-modal-image-front]');
    // var imgInside = modal.querySelector('[data-modal-image-inside]');
    var isTouchDevice = window.matchMedia('(hover: none)').matches;

    var activeCard = null;
    var CHAR_LIMIT = 300;

    /* -----------------------------------------------------------
        Helper: CLOSE minicart drawer if open 
    ------------------------------------------------------------*/
    function closeMiniCart() {
      const drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;

      // Tinker sometimes uses .close(), sometimes .closeDrawer()
      if (typeof drawer.closeDrawer === 'function') drawer.closeDrawer();
      if (typeof drawer.close === 'function') drawer.close();
    }

    /* -----------------------------------------------------------
        open popup #1
    ------------------------------------------------------------*/
    function openCardsPopup() {
      closeMiniCart();

      section.classList.add('is-open');
      section.setAttribute('aria-hidden','false');
    }

    /* -----------------------------------------------------------
        close popup #1
    ------------------------------------------------------------*/
    function closeCardsPopup() {
      section.classList.remove('is-open');
      section.setAttribute('aria-hidden','true');
    }

    /* trigger button */
    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('[data-trigger-cards-upsell]');
      if (!trigger) return;

      e.preventDefault();
      openCardsPopup();
  });

    /* close btn popup #1 */
    var popup1Close = section.querySelectorAll('[data-cart-greeting-close]');
    if (popup1Close) {
      popup1Close.forEach(function(el){
      el.addEventListener('click', closeCardsPopup);
      })
    }

    /* -----------------------------------------------------------
        HOVER ZOOM
    ------------------------------------------------------------*/
    var zoomScale = 1.5;

    cards.forEach(function(card){
      var wrap = card.querySelector('[data-card-zoom-trigger]');
      var img = card.querySelector('.js-zoom-image');
      if (!wrap || !img) return;
      if (isTouchDevice) return;

      var zoomSrc = img.getAttribute('data-zoom-src');
      if (!zoomSrc) return;

      var zoomImg = document.createElement('img');
      zoomImg.src = zoomSrc;
      zoomImg.className = 'zoomImg';
      zoomImg.alt = '';
      zoomImg.setAttribute('aria-hidden', 'true');
      wrap.appendChild(zoomImg);

      wrap.addEventListener('mouseenter', function(){
        var rect = wrap.getBoundingClientRect();
        zoomImg.style.width = rect.width * zoomScale + 'px';
        zoomImg.style.height = rect.height * zoomScale + 'px';
        zoomImg.style.opacity = '1';
      });

      wrap.addEventListener('mouseleave', function(){
        zoomImg.style.opacity = '0';
      });

      wrap.addEventListener('mousemove', function(e){
        var rect = wrap.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        var zoomWidth = zoomImg.offsetWidth;
        var zoomHeight = zoomImg.offsetHeight;

        var moveX = (x/rect.width) * (zoomWidth - rect.width);
        var moveY = (y/rect.height) * (zoomHeight - rect.height);

        zoomImg.style.left = -moveX + 'px';
        zoomImg.style.top = -moveY + 'px';
      });
      

      // CLICK --> open zoom-dialog
              wrap.addEventListener('click', function (e) {
              e.preventDefault();

              // Gather images from data-attributes
              const img1 = card.getAttribute("data-image-1");
              const img2 = card.getAttribute("data-image-2");
              const img3 = card.getAttribute("data-image-3");

              // Count images
              const images = [img1, img2, img3].filter(src => src && src.trim() !== "");

              // // If only ONE image exists --> disable zoom-dialog
              // if (images.length <= 1) {
              //     return; 
              // }

              // Else --> open zoom dialog
              closeMiniCart();
              closeCardsPopup();
              openGreetingZoom(card, images);
              });


    });


    /* -----------------------------------------------------------
    ZOOM-DIALOG
  ------------------------------------------------------------*/

  const zoomDialog = document.querySelector('#greeting-zoom-dialog');

  /* -----------------------------------------------------------
    FORCE GREETING POPUP TO STAY VISIBLE DURING ZOOM
  ------------------------------------------------------------*/

  (function patchZoomDialogShowModal() {
    const zoomDialog = document.querySelector('#greeting-zoom-dialog');
    if (!zoomDialog) return;

    const dialog = zoomDialog.querySelector('dialog');
    if (!dialog) return;

    const originalShowModal = dialog.showModal;

    dialog.showModal = function patchedShowModal() {
      originalShowModal.call(dialog);

      const greeting = document.querySelector('[data-cart-greeting]');
      if (greeting) {
        greeting.removeAttribute('inert');
        greeting.setAttribute('aria-hidden', 'false');
        greeting.classList.add('is-open');
      }
    };
  })();


  function openGreetingZoom(card) {

    const images = [
      card.getAttribute('data-image-1'),
      card.getAttribute('data-image-2') || null,
      card.getAttribute('data-image-3') || null,
    ].filter(Boolean);

    if (!images.length) return;

    const dialog = zoomDialog.querySelector('dialog');
    const mediaList = zoomDialog.querySelector('[ref="media"]');
    const thumbnails = zoomDialog.querySelector('[ref="thumbnails"]');

    mediaList.innerHTML = "";
    thumbnails.innerHTML = "";

    images.forEach((src, i) => {
      /* THUMBNAILS */
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "button button-unstyled dialog-thumbnails-list__thumbnail";
      btn.setAttribute("aria-selected", i === 0 ? "true" : "false");
      btn.style.setProperty("--aspect-ratio", "1.0");
      btn.style.setProperty("--gallery-aspect-ratio", "1.0");

      btn.addEventListener('click', () => zoomDialog.handleThumbnailClick(i));
      btn.addEventListener('pointerenter', () => zoomDialog.handleThumbnailPointerEnter(i));

      const thumbImg = document.createElement("img");
      thumbImg.src = src;
      thumbImg.alt = `thumbnail ${i+1}`;
      btn.appendChild(thumbImg);

      thumbnails.appendChild(btn);

      /* MEDIA LIST ITEMS */
      const li = document.createElement("li");
      li.className =
        "product-media-container media-fit-contain product-media-container--image product-media-container--zoomable";
      li.setAttribute("ref", "media[]");
      li.style.setProperty("--media-preview-ratio", "1.0");
      li.addEventListener("click", () => zoomDialog.close());

      li.innerHTML = `
        <drag-zoom-wrapper class="product-media__drag-zoom-wrapper">
          <div class="product-media" style="--ratio:1.0">
            <img class="product-media__image"
                src="${src}"
                data_max_resolution="${src}">
          </div>
        </drag-zoom-wrapper>
      `;

      mediaList.appendChild(li);
    });

        // --- FORCE RESET ZOOM POSITION ---
        const dialogEl = zoomDialog.querySelector('dialog');
        const mediaListEl = zoomDialog.querySelector('.dialog-zoomed-gallery');

        // safety
        if (dialogEl) dialogEl.scrollTop = 0;
        if (mediaListEl) mediaListEl.scrollTop = 0;

        // open zoom at index 0
        zoomDialog.open(0, new PointerEvent("pointerdown"));

        // --- AFTER OPEN: hard reset again (async layout fix) ---
        requestAnimationFrame(() => {
          if (mediaListEl) mediaListEl.scrollTop = 0;
          if (dialogEl) dialogEl.scrollTop = 0;

          // force thumbnail + media sync
          if (typeof zoomDialog.selectThumbnail === 'function') {
            zoomDialog.selectThumbnail(0, { behavior: 'instant' });
          }
        });

  }


    /* -----------------------------------------------------------
        Open modal #2
    ------------------------------------------------------------*/
    cards.forEach(function(card){
      var btn = card.querySelector('[data-card-customize]');
      if (!btn) return;

      btn.addEventListener('click', function(e){
        e.preventDefault();
        openModal(card);
      });
    });

    function openModal(card){

      closeMiniCart();
      closeCardsPopup();

      cards.forEach(c => c.classList.remove('is-active'));
      card.classList.add('is-active');
      activeCard = card;

      var label = card.getAttribute('data-card-label') || '';
      var img1 = card.getAttribute('data-image-1') || '';
      var img2 = card.getAttribute('data-image-2') || img1;
      var img3 = card.getAttribute('data-image-3') || img1;
      var priceLabel = card.getAttribute('data-price-label') || '';

      imgFront.classList.add('is-fading');
      //imgInside.classList.add('is-fading');

      setTimeout(function(){
        imgFront.src = img2;
        //imgInside.src = img3;
        imgFront.onload = ()=> imgFront.classList.remove('is-fading');
        //imgInside.onload = ()=> imgInside.classList.remove('is-fading');
      },150);

      textarea.value = '';
      updateCharCount();

      addBtn.textContent =
        'Add Card to Cart' + (priceLabel ? ' (' + priceLabel + ')' : '');

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal(){
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
      activeCard = null;

      imgFront.src = '';
      //imgInside.src = '';
    }

    /* Return --> go back to popup #1 */
    if (modalReturn) {
      modalReturn.addEventListener('click', function(){
        modal.classList.remove('is-open');
        document.body.style.overflow='';
        openCardsPopup();
        if (activeCard) activeCard.classList.add('is-active');
      });
    }

    /* close modal #2 */
    modalCloseEls.forEach(function(el){
      el.addEventListener('click', closeModal);
    });

    modal.querySelector('.cart-greeting-modal__overlay')
        .addEventListener('click', closeModal);

    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') {
        if (modal.classList.contains('is-open')) closeModal();
        else if (section.classList.contains('is-open')) closeCardsPopup();
      }
    });

    /* Textarea counter */
    function updateCharCount(){
      var used = textarea.value.length;
      if (used > CHAR_LIMIT) {
        textarea.value = textarea.value.slice(0, CHAR_LIMIT);
        used = CHAR_LIMIT;
      }
      countEl.textContent = CHAR_LIMIT - used;
    }
    textarea.addEventListener('input', updateCharCount);

    /* -----------------------------------------------------------
        Add to cart
    ------------------------------------------------------------*/
    addBtn.addEventListener('click', function(){
      if (!activeCard) return;

      var message = textarea.value.trim();
      if (!message) {
        errorEl.textContent = 'Please enter your message.';
        errorEl.style.display='block';
        textarea.classList.add('empty-message');
        return;
      }

      var variantId = activeCard.getAttribute('data-variant-id');
      if (!variantId) {
        errorEl.textContent = 'Unable to add this card.';
        errorEl.style.display='block';
        return;
      }

      addBtn.disabled = true;
      textarea.classList.remove('empty-message');

      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({
          id:Number(variantId),
          quantity:1,
          properties:{
            'Message':message,
            '__Greeting timestamp': new Date().toISOString()
          }
        })
      })
      .then(r=>r.json())
      .then(function() {

    closeModal();

    fetch(window.Shopify.routes.root + 'cart?sections=cart-drawer,cart-items,cart-icon-bubble')
      .then(r => r.text())
      .then(htmlText => {

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');

        const sections = {
          'cart-drawer': doc.querySelector('[data-section-id="cart-drawer"]')?.innerHTML || '',
          'cart-items': doc.querySelector('[data-section-id="cart-items"]')?.innerHTML || '',
          'cart-icon-bubble': doc.querySelector('[data-section-id="cart-icon-bubble"]')?.innerHTML || '',
        };

        document.dispatchEvent(
          new CustomEvent("cart:update", {
            bubbles: true,
            detail: {
              data: { sections }
            }
          })
        );

        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === "function") {
          drawer.open();
        }

      });
  })

      .catch(()=>{
        errorEl.textContent='Something went wrong.';
        errorEl.style.display='block';
      })
      .finally(()=> addBtn.disabled=false );
    });
  });